import * as React from "react";
import { openExternalUrl } from "../external_link";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppList, AppListItem } from "./Generic/AppList";
import TrailingChevron from "./Generic/TrailingChevron/TrailingChevron";
import GenericSettingsScreen from "./GenericSettingsScreen";

interface SettingsGeneralScreenProps {
  onClickGoBack: () => void;
}

const SettingsGeneralScreen = (props: SettingsGeneralScreenProps) => {
  const handleClickTermsOfUse = React.useCallback(() => {
    openExternalUrl("http://www.medflyt.com/terms");
  }, []);

  const handleClickPrivacyPolicy = React.useCallback(() => {
    openExternalUrl("http://www.medflyt.com/privacy");
  }, []);

  return (
    <GenericSettingsScreen title={translate(STRINGS.GENERAL)} onClickGoBack={props.onClickGoBack}>
      <AppList bordered={true}>
        <AppListItem
          title={translate(STRINGS.TERMS_OF_USE)}
          trailing={<TrailingChevron />}
          onClick={handleClickTermsOfUse}
        />

        <AppListItem
          title={translate(STRINGS.PRIVACY_POLICY)}
          trailing={<TrailingChevron />}
          onClick={handleClickPrivacyPolicy}
        />
      </AppList>
    </GenericSettingsScreen>
  );
};

export default React.memo(SettingsGeneralScreen);
